import { render } from "./FooterPart.vue?vue&type=template&id=ec7e4ce2"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import "./FooterPart.vue?vue&type=style&index=0&id=ec7e4ce2&lang=css"

import exportComponent from "/home/jan/Documents/projects/unity/makler-microsite/vue-form/microsite-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__